import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { Layout } from "./components/Layout";
import Interview from "./pages/Interview";
import Work from "./pages/Work";
import CasePage from "./pages/CasePage";
import Resume from "./pages/Resume";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Interview />} />
              <Route path="/work" element={<Work />} />
              <Route path="/work/:slug" element={<CasePage />} />
              <Route path="/resume" element={<Resume />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
